import { observable } from '@/libs/state'
import { DEFAULT_PERMISSION_CONFIG, PERMISSIONS_DENIED } from './domain/permission'
import type { PermissionConfiguration, PermissionUser, ResolvedPermissions, RolePermissionConfig, UserPermissionOverride } from './domain/permission'

const permissions$ = observable<ResolvedPermissions>(PERMISSIONS_DENIED)
const permissionConfig$ = observable<PermissionConfiguration>(DEFAULT_PERMISSION_CONFIG)
const permissionUsers$ = observable<PermissionUser[]>([])
const draftRoleConfigs$ = observable<RolePermissionConfig[]>(DEFAULT_PERMISSION_CONFIG.roleConfigs)
const draftUserOverrides$ = observable<UserPermissionOverride[]>(DEFAULT_PERMISSION_CONFIG.userOverrides)

export { permissions$, permissionConfig$, permissionUsers$, draftRoleConfigs$, draftUserOverrides$ }
